import { CORE_API_URL } from '../../config';
import { getClientAccessToken, refreshClientAccessToken } from '../auth/clientSession';
import { handleUnauthorized } from '../auth/handleUnauthorized';
import { createAuthedApiClient } from './client';

// Authenticated core API client for browser-side data fetching (use instead of `coreApiClient`).
export const coreApiAuthedClient = createAuthedApiClient(CORE_API_URL, {
  getAccessToken: getClientAccessToken,
  refreshAccessToken: refreshClientAccessToken,
  onUnauthorized: handleUnauthorized,
});
